import React, { useRef, useEffect } from "react";
import { useTireReading } from "@/app/context/TireReadingContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTire } from "@awesome.me/kit-7e217e7a3f/icons/classic/solid";

// const granuGreen = "#31997A";

const HistoryBar: React.FC = () => {
  const { readings = [], currentIndex, setCurrentIndex } = useTireReading();
  const containerRef = useRef<HTMLDivElement>(null);
  const prevReadingsLength = useRef(readings.length);

  useEffect(() => {
    if (containerRef.current && readings.length > prevReadingsLength.current) {
      containerRef.current.scrollLeft = containerRef.current.scrollWidth;
    }
    prevReadingsLength.current = readings.length;
  }, [readings.length]);

  return (
    <div
      className="flex flex-row items-center gap-4 w-full mb-4 overflow-x-auto whitespace-nowrap px-4"
      style={{
        height: 78,
        minHeight: 90,
        overflowY: "hidden",
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: "thin",
        msOverflowStyle: "auto",
      }}
      ref={containerRef}
    >
      <div style={{ flex: 1, minWidth: 0 }} />
      {readings.map((reading, idx) => {
        const isChecked = reading.checked;
        const isCurrent = idx === currentIndex;
        return (
          <button
            key={reading.id}
            onClick={() => setCurrentIndex(idx)}
            className={`w-10 h-10 rounded-full border-2 flex items-center justify-center transition-all
              ${
                isChecked
                  ? "bg-[var(--granu-green)] border-[var(--granu-green)]"
                  : "bg-gray-300 border-[#dda442]"
              }
              ${isCurrent ? "ring-4 ring-[#dda442] scale-110 z-10" : ""}
            `}
            aria-label={`Go to reading ${idx + 1}`}
            style={{ minWidth: 70, minHeight: 70 }}
          >
            <FontAwesomeIcon
              icon={faTire}
              size="2xl"
              color={isChecked ? "white" : "#888"}
              className=""
            />
          </button>
        );
      })}
      {/* Hide scrollbar for Webkit browsers */}
      <style jsx>{`
        div::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
};

export default HistoryBar;
